import { GridRequest } from 'projects/app-core/src/models/gridRequest';

// Enums for type safety - limiting sort fields to lastUpdated and createdAt
export enum FitnessLogsSortFields {
  LAST_UPDATED = "lastUpdated",
  CREATED_AT = "createdAt",
}

// Filters for the grid
export enum FitnessLogsFilterFields {
  EVENTS = "events",
  STATUS = "status",
  PARTNER_ID = "partnerId",
  TITLE = "title",
  HIDE_TEST_BOOKING = "HIDE_TEST_BOOKING",
}

// Search fields for the grid
export enum FitnessLogsSearchFields {
  USER_EMAIL = "userEmail",
  WORKOUT_NAME = "workoutName",
  PLAN_NAME = "planName",
  CHALLENGE_NAME = "challengeName",
}

// Date filter fields
export enum FitnessLogsDateFields {
  CREATED_AT = "createdAt",
}

// Extend base GridRequest
export interface FitnessLogsGridRequest
  extends GridRequest<
    FitnessLogsSortFields,
    FitnessLogsFilterFields,
    FitnessLogsSearchFields,
    FitnessLogsDateFields
  > {}
